export default class NotificaEmailService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
        this._ctrl = store.getters.getAbortCtrl;
    }

    filtrarEmail(filtros, nr_pagina, nr_email_pagina) {
        filtros.apresentante = this._store.getters.cdApresentante;
        filtros.pagina = nr_pagina;
        filtros.email_por_pagina = nr_email_pagina;
        return this._http.get('notifica/email/campanhas/listar', {
            params: filtros
        });
    }

    listarTemplates() {
        return this._http.get('notifica/email/templates/listar');
    }

    detalheCampanhaEmail(email) {
        return this._http.get('notifica/email/campanhas/detalhe', {
            params: { campaign: email.id }
        });
    }

    verificaContatosCampanha(campanha) {
        return this._http.get('notifica/email/campanhas/contatos', {
            params: { campaign: campanha }
        });
    }

    atualizaStatusCampanhaEmail(campanha) {
        return this._http.patch('notifica/email/campanhas', {
            campanha
        });
    }

    salvarCampanhaEmail(data) {
        var response = null;
        if (data.id) {
            let payload = {
                id: data.id,
                is_active: data.is_active === true ? 'true' : 'false',
                created_by_title: data.created_by_title
            };
            response = this._http.patch('notifica/email/campanhas', {
                payload
            });
        } else {
            response = this._http.post('notifica/email/campanhas', {
                data
            });
        }
        return response;
    }
}
